module.exports = __webpack_public_path__ + "img/thumbnail_SnowLeopard_f_normal.e3251fc2.png";